import { render, staticRenderFns } from "./CategoriesClouds.vue?vue&type=template&id=45262bdc"
import script from "./CategoriesClouds.vue?vue&type=script&lang=js"
export * from "./CategoriesClouds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports